<template>
  <section class="relative bg-position-top py-16 z-0">
    <UContainer>
      <NuxtImg
        format="webp"
        src="/images/philosophy/1.webp"
        class="w-full h-full object-cover absolute inset-0"
        alt=""
        aria-hidden="true"
        role="presentation"
        lazy
      />

      <div
        class="px-6 py-12 text-center bg-stone-800 shadow-sm dark max-w-98 relative z-1 mx-auto lg:ml-auto lg:mx-0"
      >
        <h2
          class="uppercase text-2xl leading-none font-medium mb-6 text-transparent bg-clip-text bg-gradient-to-b from-[#7B7B7B] via-[#B4B4B4] to-[#B4B4B4]"
        >
          Join Our Exclusive List
        </h2>

        <p class="leading-6 text-white text-sm">
          ARCHE - A DEBUT COLLECTION OF PRECISION-CRAFTED TITANIUM EYEWEAR IN
          LIMITED NUMBERS.
          <br />
          <br />
          SHARE YOUR EMAIL TO RECEIVE YOUR <b>20%</b> PRIVILEGE.
        </p>

        <ClientOnly>
          <TheSubscriptionForm class="mt-6 mb-3" />
        </ClientOnly>

        <p class="text-xs leading-6 text-stone-300 px-8">
          By clicking "Subscribe" you are accepting our
          <ULink
            :to="
              $localePath({
                name: 'support-slug',
                params: { slug: 'terms-and-conditions' }
              })
            "
            class="text-stone-300 hover:text-stone-300 underline hover:no-underline"
            >terms and conditions</ULink
          >
        </p>
      </div>
    </UContainer>
  </section>
</template>

<style scoped></style>
